$(function(){
    //搜索功能
    $(document).click(function(e){
        var target = $(e.target);
        if(target.closest(".searchBox").length !== 0) return;
        $('.searchBox .hot-search-content').slideUp();
    });

    //回车搜索
    $("#header-search-input").keydown(function(event) {
        if (this.value) {
            $('.searchCon .hot-search-content').hide();
        } else {
            $('.searchCon .hot-search-content').show();
        }
        var value=$('#header-search-input').val();
        //去左右空格;
        value = value.replace(/(^\s*)|(\s*$)/g, "");
        if (event.keyCode == 13 && value != '') {
            //执行操作
            gioEvarAction.searchEvar(value);
            window.open(solution_host+'/list' + '?type=' + window.cateData.searchType + '&kw=' +encodeURI(value)+ '&searchmodule=' + window.cateData.userRecodeOption.module);
        }
    });

    //搜索按钮点击
    $(".searchBox .searchBtn").click(function () {
        if (this.value) {
            $('.searchCon .hot-search-content').hide();
        } else {
            $('.searchCon .hot-search-content').show();
        }
        var value=$('#header-search-input').val();
        //去左右空格;
        value = value.replace(/(^\s*)|(\s*$)/g, "");
        if (value !== '') {
            //执行操作
            gioEvarAction.searchEvar(value);
            window.open(solution_host+'/list' + '?type=' + window.cateData.searchType + '&kw=' +encodeURI(value)+ '&searchmodule=' + window.cateData.userRecodeOption.module);
        }
    });

    $('#header-search-input').on('focus', function () {
        // if (this.value) return;
        $('#eac-container-header-search-input').hide();
        setTimeout(function () {
            $('.searchBox .hot-search-content').show();
        },500);
    })
    $('.searchBox .hot-search-content ul li').on('click', function () {
        $('.pcSoBox .hot-search-content').hide();
    })

    $('.navItemList .navErBtn').hover(function () {
        $(this).find('.xiaList').stop();
        $(this).find('.xiaList').fadeIn(400);
    }, function () {
        $(this).find('.xiaList').stop();
        $(this).find('.xiaList').fadeOut(400);
    });

    // list导航按钮
    var isShowAllNav = true;
    $('.allNavBtn').on('click', function () {
        if (!isShowAllNav) {
            $('.allNavBox').stop();
            $('.allNavBox').fadeIn(400);
        } else {
            $('.allNavBox').stop();
            $('.allNavBox').fadeOut(400);
            $('.allNavBtn').css({
                'background-color': 'rgba(0,0,0,0)'
            })
        }
        $('.allNavBtn .icon-guanbi1').toggleClass('hide');
        $('.allNavBtn .icon-liebiao-1').toggleClass('hide');
        isShowAllNav = !isShowAllNav;
    });
    var allNavTime;
    $('.allNavBtn').hover(function () {
        inItList();
        clearTimeout(allNavTime);
        $('.allNavBox').stop();
        $(this).children('.icon-liebiao-1').addClass('hide');
        $(this).children('.icon-guanbi1').removeClass('hide');
        $('.allNavBox').fadeIn(400);
    }, function () {
        allNavTime = setTimeout(function () {
            $('.allNavBox').stop();
            $('.allNavBox').fadeOut(400);
            $('.allNavBtn .icon-guanbi1').addClass('hide');
            $('.allNavBtn .icon-liebiao-1').removeClass('hide');
            $('.allNavBtn').css({
                'background-color': 'rgba(0,0,0,0)'
            })
        }, 50)
    });
    $('.allNavBox').hover(function () {
        clearTimeout(allNavTime);
    }, function () {
        $('.allNavBox').stop();
        $('.allNavBox').fadeOut(400);
        $('.allNavBtn .icon-guanbi1').addClass('hide');
        $('.allNavBtn .icon-liebiao-1').removeClass('hide');
        $('.allNavBtn').css({
            'background-color': 'rgba(0,0,0,0)'
        })
    });
    // 个人中心--模拟cookie登录/退出
    var isShowMeCore = true;

    // 有二级导航的
    $('.navErBtn').attr('data-bok', 'ok');
    $('.navErBtn').on('click', function () {
        inItList();
        if ($(this).attr('data-bok') == 'ok') {
            $('.navErBtn .xiaList').stop();
            $('.navErBtn .xiaList').fadeOut(400);
            $('.navErBtn').attr('data-bok', 'ok');

            $(this).find('.xiaList').stop();
            $(this).find('.xiaList').fadeIn(400);
            $(this).attr('data-bok', 'no')
        } else {
            $('.navErBtn .xiaList').stop();
            $('.navErBtn .xiaList').fadeOut(400);
            $(this).attr('data-bok', 'ok')
        }
    });

    function inItList() {
        isShowAllNav = isShowProduct = isShowMeCore = true;
        $('.navErBtn').attr('data-bok', 'ok');
        $('.productListBox').stop();
        $('.meCoreList').stop();
        $('.productListBox').fadeOut(400);
        $('.meCoreList').fadeOut(400);
        $('.meCore').css({
            'background-color': 'rgba(0,0,0,0)'
        });
        $('.allNavBox').stop();
        $('.allNavBox').fadeOut(400);
        $('.allNavBtn').css({
            'background-color': 'rgba(0,0,0,0)'
        });
        $('.pcSoBtn').css({
            'background-color': 'rgba(0,0,0,0)'
        });
        $('.navErBtn .xiaList').stop();
        $('.navErBtn .xiaList').fadeOut(400);
    }

    // 底部下拉列表
    $('.allNavCont .title').attr('data-bok', 'ok');
    $('.allNavCont .title').on('click', function () {
        if (window.innerWidth < 735) {
            if ($(this).attr('data-bok') == 'ok') {
                $('.allNavCont .title').next().stop();
                $('.allNavCont .title').next().fadeOut(400);
                $('.allNavCont .title span').html('+');
                $('.allNavCont .title').attr('data-bok', 'ok');
                $(this).attr('data-bok', 'no');
                $(this).next().stop();
                $(this).next().fadeIn(400);
                $(this).find('span').html('-')
            } else {
                $(this).next().stop();
                $(this).next().fadeOut(400);
                $(this).attr('data-bok', 'ok');
                $('.allNavCont .title span').html('+')
            }
        }
    })

    // 导航弹窗功能
    var $userInfoCard = $('#nav-user-info-card'); //用户登录信息 //PM:已登陆状态鼠标hover后显示，鼠标移除自动隐藏
    var $qrcodeCard = $('#nav-qrcode-card'); // 登录后的二维码弹船 //PM: 二维码弹窗为已登陆状态下默认弹出，点击可关闭，扫码进入到小程序。
    var $regTips = $('#nav-reg-tips'); // 未登录的注册提示，跳转到promotion落地页 //PM:该弹窗为未登录状态下，弹窗默认弹出，不可关闭，注册登陆后隐藏，点击弹窗跳转活动页登陆注册位置
    var userCardInfoData = null; // 用于存储接口信息

    if(common.isLogin()){
        if(isCompaign() && !common.getCookie('nav-user-qrcode-card-'+ common.isLogin().memberId)){
            $qrcodeCard.show();
        }
        $qrcodeCard.find('.close').click(function () {
            $qrcodeCard.hide();
            common.setCookie('nav-user-qrcode-card-'+ common.isLogin().memberId, true, 7);
        });
        $('.meCore').addClass('meCore-is-login')

        $('.meCore-is-login').hover(setUserCardInfo, null);
    }else{
        if(isCompaign()) {
            $regTips.show()
        }
    }

    // 是否是活动页面
    function isCompaign() {
        return location.href.indexOf('campaign') === -1
    }
    // 设置用户面板的信息
    var isGetUserCardInfoIng = true;
    function setUserCardInfo() {
        if(!isGetUserCardInfoIng){
            return false
        }
        isGetUserCardInfoIng = false;
        console.log('获取用户信息');
        var userSess = common.isLogin();
        var info = {
            "session": userSess.session,
            "OCSESSID": userSess.OCSESSID
        }

        // 从缓存获取信息

        if(userCardInfoData){
            setInfo(userCardInfoData);
            return;
        }

        // 从接口获取信息
        common.postJson(solution_host + '/api/account/info', info, function (res) {
            isGetUserCardInfoIng = true;
            if(res.errCode !== 0){
                return;
            }

            userCardInfoData = res.data;
            setInfo(userCardInfoData)
        })

        function setInfo(userCardInfo) {
            $('#nav-user-card-order').text(userCardInfo.record.order || 0);
            $('#nav-user-card-collect').text(userCardInfo.record.collect || 0);
            $('#nav-user-card-coupon').text(userCardInfo.record.coupon || 0);
            $('#nav-user-card-schedule').text(userCardInfo.record.schedule || 0);
            $('#nav-user-card-name').text(userCardInfo.user_info.realname || '匿名');
            $('#nav-user-card-avatar').attr('src', userCardInfo.user_info.avatar || '/static/default/avatar.png');
            $('#nav-user-card-enterprise_name').text(userCardInfo.user_info.enterprise_name || '未设置');
            $('#nav-user-info-card-loading').hide();
        }
    }

    // pc导航显示显示广告
    var activeBox = $('.navBox .active-box'); // 广告盒子
    var activeBoxClose = $('.navBox .active-box .close-btn'); // 广告盒子关闭按钮
    var activeBoxBlock = $('.active-box-block'); // 页面垫高的盒子 默认20px 广告出来后 变为100px


    // 是否屏蔽广告 返回是的 不展示广告
    function isAdvert() {
        var result = false;
        var list = ['/campaign'];
        list.forEach(function (item) {
            if (location.href.indexOf(item) > -1) {
                result = true;
            }
        })
        return result
    }
    if (!isAdvert() && !common.getCookie('advertCloseClick')) {
        common.getJson(solution_host + '/api/common/banner/get', {
            equipment: 'pc',
            cateId: '2312111353852016'
        }, function (res) {
            if (res.data && res.data.content.length > 0) {
                activeBox.css('background-image', 'url("'+ res.data.content +'")').show();
                activeBoxBlock.height(100);
                activeBoxClose.click(function () {
                    activeBox.hide();
                    activeBoxBlock.height(20);
                    common.setCookie('advertCloseClick', true, 1);
                })
            }
        })
    }
});

//全部导航选中效果
$('.bigNavList .felxItem').hover(function () {
    $(this).find('.ckLine').stop();
    $(this).find('.ckLine').fadeIn(400).css('display','inline-block');
}, function () {
    $(this).find('.ckLine').stop();
    $(this).find('.ckLine').fadeOut(400);
});

//三级导航
$('.nohover').hover(function () {
    $(this).find('.cpsolution').stop();
    $(this).find('.cpsolution').fadeIn(400);
}, function () {
    $(this).find('.cpsolution').stop();
    $(this).find('.cpsolution').fadeOut(400);
});

// 设置导航上登录名
setTimeout(function () {
    if(common.isLogin()){
        getUserInfoDef.then(function (res) {
            console.log(res);
            var setUserName = res.name || res.mobile.substr(-4);
            $('.meCore .header-user-icon').hide();
            $('.no-login-text').hide();
            $('.meCore .login-user-name').css('display','block');
            $('.meCore .login-user-name').text(setUserName);
        });
    }
}, 100);
